export const key = 'moises:utm'
export * from './use-get-utm-storage'
export * from './use-set-utm-storage'
